import React from "react";

const CommentSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse">
      {/* Mobile Skeleton Card */}
      <div className="md:hidden min-w-[313px] w-[343px] h-[250px] rounded-2xl border border-gray-200 p-[16px] flex flex-col justify-between bg-white">
        {/* Header: Avatar + Text + Rate */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-[54px] h-[54px] rounded-full bg-gray-200"></div>
            <div className="flex flex-col gap-2">
              <div className="h-3 w-24 bg-gray-200 rounded"></div>
              <div className="h-2 w-16 bg-gray-200 rounded"></div>
            </div>
          </div>
          <div className="h-4 w-4 bg-gray-200 rounded"></div>
        </div>

        {/* Body: Comment Lines */}
        <div className="flex-1 flex flex-col justify-center gap-2 pt-[20px]">
          <div className="h-3 w-full bg-gray-200 rounded"></div>
          <div className="h-3 w-full bg-gray-200 rounded"></div>
          <div className="h-3 w-5/6 bg-gray-200 rounded"></div>
        </div>

        {/* Footer: Place Info */}
        <div className="flex items-center gap-2 mt-4">
          <div className="w-6 h-6 rounded-full bg-gray-200"></div>
          <div className="h-4 w-24 bg-gray-200 rounded"></div>
        </div>
      </div>

      {/* Desktop Skeleton Card */}
      <div className="hidden md:block min-w-[313px] w-[343px] h-[252px] rounded-2xl border border-gray-200 p-[16px] flex flex-col justify-between bg-white">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-[54px] h-[54px] rounded-full bg-gray-200"></div>
            <div className="flex flex-col gap-2">
              <div className="h-3 w-24 bg-gray-200 rounded"></div>
              <div className="h-2 w-16 bg-gray-200 rounded"></div>
            </div>
          </div>
          <div className="h-4 w-4 bg-gray-200 rounded"></div>
        </div>

        {/* Body */}
        <div className="flex-1 flex flex-col justify-center gap-2 pt-[30px]">
          <div className="h-3 w-full bg-gray-200 rounded"></div>
          <div className="h-3 w-full bg-gray-200 rounded"></div>
          <div className="h-3 w-full bg-gray-200 rounded"></div>
          <div className="h-3 w-4/5 bg-gray-200 rounded"></div>
        </div>

        {/* Footer */}
        <div className="flex items-center gap-2 mt-4">
          <div className="w-10 h-10 rounded-full bg-gray-200"></div>
          <div className="h-5 w-32 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default CommentSkeleton;